import { put, select } from 'redux-saga/effects'

import { track as trackEvent } from '../../actions/tracking'
import { selectProduct } from '../../selectors/product'
import { CONTEXT_DETAIL, ORIGIN_PRODUCT } from '../../../helpers/const'
import { selectCurrentCollectionIndex } from '../../selectors/ux'

function* onProductCallCtaClick(action) {
  const { params: { productId } } = action.payload

  const product = yield select(selectProduct(productId))
  const position = (yield select(selectCurrentCollectionIndex)) + 1 // from 1 to N

  yield put(trackEvent({
    event: 'callProduct',
    params: {
      id: product.id,
      title: product.title,
      to: `${ORIGIN_PRODUCT}-${CONTEXT_DETAIL}`,
      position,
    },
  }))
}

export default onProductCallCtaClick
